import { render, staticRenderFns } from "./DashboardNotificationsContainer.vue?vue&type=template&id=364b1d9f&scoped=true"
import script from "./DashboardNotificationsContainer.vue?vue&type=script&lang=js"
export * from "./DashboardNotificationsContainer.vue?vue&type=script&lang=js"
import style0 from "./DashboardNotificationsContainer.vue?vue&type=style&index=0&id=364b1d9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364b1d9f",
  null
  
)

export default component.exports